import { mapActions, mapGetters } from 'vuex';
import { Flicking, MOVE_TYPE } from '@egjs/vue-flicking';
import '@egjs/vue-flicking/dist/flicking.css';
import IconArrowPrevDark from '@/components/icons/IconArrowPrevDark.vue';
import IconArrowNextDark from '@/components/icons/IconArrowNextDark.vue';
import { MEDIA } from '@/helpers/variables';

export default {
  name: 'Banner',
  components: {
    IconArrowNextDark,
    IconArrowPrevDark,
    Flicking
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      MEDIA,
      MOVE_TYPE,
      autoplayInterval: null,
      autoplayIntervalSeconds: 10
    };
  },
  created() {
    this.startAutoplay();
  },

  computed: {
    ...mapGetters({
      appSize: 'app/size',
      home: 'pages/page'
    })
  },
  methods: {
    ...mapActions({}),
    onPrevSlide() {
      if (!this.$refs.refFlicking.animating) {
        this.$refs.refFlicking.prev();
      }
    },
    onNextSlide() {
      if (!this.$refs.refFlicking.animating) {
        this.$refs.refFlicking.next();
      }
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        if (!this.$refs.refFlicking.animating) {
          this.$refs.refFlicking.next();
        }
      }, this.autoplayIntervalSeconds * 1000);
    }
  },
  beforeDestroy() {
    clearInterval(this.autoplayInterval);
  }
};
